/**
 * Labstep
 *
 * @module components/Folder/Card/Manager
 * @desc Folder Manager Card component
 */

import { Action } from 'labstep-web/components/Entity/Can/types';
import { EntityListToggle as EntityToggleList } from 'labstep-web/components/Entity/ListToggle';
import { FolderList } from 'labstep-web/components/Folder/List';
import { ICONS } from 'labstep-web/constants/icons';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { Button } from 'labstep-web/core/Button';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import { Folder } from 'labstep-web/models/folder.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import styles from './styles.module.scss';
import type { FolderManagerProps } from './types';

export const FolderManager: React.FC<FolderManagerProps> = ({
  parentEntity,
  activeGroup,
  open,
  onClose,
}) => (
  <Modal
    header="Manage Collections"
    viewComponent={({ toggleModal }) => (
      <Popup
        trigger={
          <Button
            onClick={toggleModal}
            icon={ICONS.folder.primary}
            circular
          />
        }
        content="Manage Collections"
        size="mini"
      />
    )}
    initialModalState={open}
    onClose={onClose}
    content={
      <EntityToggleList
        parent={parentEntity}
        entityName={Folder.entityName}
        labelKey="folder_path"
        caseSensitive={false}
        extraParams={{
          group_id: activeGroup?.id,
          count: 50,
        }}
        creatable
        createBody={{ type: parentEntity.entityName }}
        actionMessageIcon={ICONS.folder.primary}
        list={({ entities }) => (
          <FolderList
            folders={entities}
            parentEntity={parentEntity}
          />
        )}
      />
    }
  />
);

export default withActiveGroup(FolderManager);
